import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const [promoVisible, setPromoVisible] = useState(true);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__inner">
        <div className="site-footer__top">
          <div className="site-footer__col">
            <h2 className="site-footer__col-title">FYI</h2>
            <ul className="site-footer__list">
              <li>
                <Link
                  className="site-footer__link"
                  to="/contact"
                  onClick={toTop}
                >
                  Contact Us
                </Link>
              </li>

              <li>
                <Link
                  className="site-footer__link"
                  to="/shipping"
                  onClick={toTop}
                >
                  Shipping Info
                </Link>
              </li>

              <li>
                <Link
                  className="site-footer__link"
                  to="/returns"
                  onClick={toTop}
                >
                  Returns &amp; Exchanges
                </Link>
              </li>
            </ul>
          </div>

          <div className="site-footer__col">
            <h2 className="site-footer__col-title">Stay Connected</h2>

            <p>
              <a
                className="site-footer__link"
                href="mailto:buyer@mvandora.store"
              >
                buyer@mvandora.store
              </a>
            </p>

            <p>
              ENZIROT LIMITED
              <br />
              291597 OFFICE SUITE 29A, 3/F 23 WHARF STREET, LONDON, ENGLAND SE8
              3GG
            </p>
          </div>
        </div>

        <div className="site-footer__brand">
          <span className="site-footer__brand-script">mvandora</span>
        </div>

        <div className="site-footer__legal">
          <nav className="site-footer__legal-links" aria-label="Legal">
            <Link
              className="site-footer__legal-link"
              to="/privacy"
              onClick={toTop}
            >
              Privacy Policy
            </Link>
            <Link
              className="site-footer__legal-link"
              to="/terms"
              onClick={toTop}
            >
              Legal
            </Link>
          </nav>
          <p className="site-footer__copyright">
            © 2026 mvandora. All Rights Reserved.
          </p>
        </div>
      </div>

      {promoVisible ? (
        <div className="site-footer__promo" role="status">
          <button
            type="button"
            className="site-footer__promo-close"
            onClick={() => setPromoVisible(false)}
            aria-label="Dismiss promotion"
          >
            ×
          </button>
          <span>New Here? Take 15% Off</span>
        </div>
      ) : null}
    </footer>
  );
}

export default Footer;
